import { useDispatch } from 'react-redux'
import { MapDataSettingsDrawer as Drawer } from 'ui-components'
import {
  closeMapDataSettingsDrawer,
  openMapDescriptionDrawer,
  useIsMapDataSettingsDrawerOpen
} from '~map-preview/states/ui'

import { Description } from './Description'
import { Map } from './Map'

function MapDataSettingsDrawer() {
  const dispatch = useDispatch()
  const open = useIsMapDataSettingsDrawerOpen()

  const handleClose = () => {
    dispatch(closeMapDataSettingsDrawer())
    dispatch(openMapDescriptionDrawer())
  }

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      slots={{ Map, Description }}
    />
  )
}

export { MapDataSettingsDrawer }
